import React, {useState, useEffect} from 'react'

import pill from "./../../../UI/general/pill.svg"
import all from "./../../../UI/general/all.svg";
import all_white from "./../../../UI/general/all_white.svg";

interface SidebaramenitiesMobileProps {
  amenitiesData: any,
  colorsData: any,
  handleamenitiesMenySelection: any,
  handleamenitiesFilter: any,
  handleamenitiesAttributesFilter: any,
  amenitiesFilterId: string,
  amenitiesFilterAttributeId: any,
  handleOpenAmenitiesSpin: any,
  handleCloseAmenitieSpin: any
}
declare const window: any;

/*eslint-disable*/

const SidebarAmenitiesV2Mobile = ({
  amenitiesData, 
  colorsData, 
  handleamenitiesMenySelection,
  handleamenitiesFilter,
  handleamenitiesAttributesFilter,
  amenitiesFilterId,
  amenitiesFilterAttributeId,
  handleOpenAmenitiesSpin,
  handleCloseAmenitieSpin
}: SidebaramenitiesMobileProps) => {

  const [isamenitiesHidden, setamenitiesHidden] = useState(false)
  const [amenityIndex, setamenityIndex] = useState(-1)
  const [selectedamenityIndex, setSelectedamenityIndex] = useState(0)
  const [selectedamenityAttributeIndex, setSelectedamenityAttributeIndex] =
    useState(0);
  const [amenityOptionSelectedIndex, setamenityOptionSelectedIndex] = useState(-1)
  const [amenityOptionIndex, setamenityOptionIndex] = useState(-1)

  const [spinOpened, setSpinOpened] = useState(false)
  const [spinData, setSpinData] = useState()

  useEffect(() => {
    (async () => {
        var svgObj: any = document.querySelector('#selected-btn-amenities')
        if(svgObj){
            await fetch(svgObj.data)
            .then((response => response.blob()))
            .then((data) => {
                var url = URL.createObjectURL(data)
                svgObj.data = url
                svgObj.addEventListener('load', () => {
                    var svgDoc = svgObj.contentDocument
                    var paths = svgDoc.querySelectorAll('path')
                    paths.forEach((path: any) => {
                        path.setAttribute('fill',colorsData.secondary_text)
                    })
                    var defs = svgDoc.querySelectorAll('defs')
                    var svg = svgDoc.querySelector('svg')
                    svg.removeChild(defs[0])
                })
            })

        }
    })();
}, [selectedamenityIndex, amenitiesFilterId, colorsData]);

useEffect(() => {
  (async () => {
      var svgObjSpin: any = document.querySelector('#selected-btn-amenities-spin')
      if(svgObjSpin){
          await fetch(svgObjSpin.data)
          .then((response => response.blob()))
          .then((data) => {
              var url = URL.createObjectURL(data)
              svgObjSpin.data = url
              svgObjSpin.addEventListener('load', () => {
                  var svgDoc = svgObjSpin.contentDocument
                  if(svgDoc !== null){
                      var paths = svgDoc.querySelectorAll('path')
                      paths.forEach((path: any) => {
                          path.setAttribute('fill',colorsData.secondary_text)
                      })
                      var defs = svgDoc.querySelectorAll('defs')
                      var svg = svgDoc.querySelector('svg')
                      if(defs[0]){
                          svg.removeChild(defs[0])
                      }
                  }
              })
          })

      }
  })();
}, [spinOpened, colorsData]);

useEffect(() => {
    (async () => {
        var svgObj: any = document.querySelectorAll('#unselected-btn-amenities')
        if(svgObj){
            svgObj.forEach((obj: any) => {
                var svgDoc = obj.contentDocument
                var paths = svgDoc.querySelectorAll('path')
                paths.forEach((path: any) => {
                    path.setAttribute('fill',colorsData.main_text)
                })
            })
        }
    })();
}, [selectedamenityIndex, amenitiesFilterId, colorsData]);

useEffect(() => {
  if(spinOpened){
      handleOpenAmenitiesSpin(spinData)
  }
  else{
      handleCloseAmenitieSpin()
  }
}, [spinOpened,spinData, handleOpenAmenitiesSpin, handleCloseAmenitieSpin])

  return(
    <div className={isamenitiesHidden ? "amenities-sidebar-container-collapsed":"amenities-sidebar-container-opened"} style={{pointerEvents: "all"}}>
      <div className='hide-amenities-mobile-container' onClick = {() => {setamenitiesHidden(!isamenitiesHidden)}}>
        <img src={pill} alt=""></img>
      </div>
      {
        !isamenitiesHidden ?
        <div className='options-amenities-container-mobile'>
          <div className='options-amenities-name'>
            <img src={amenitiesData.icon} alt=""/>
            <div>Amenidades</div>
          </div>
          <div className='options-amenities-btns-container'>
            <div 
              className='options-amenity-individual-btn'
              style={{
                backgroundColor: selectedamenityAttributeIndex === 0 && amenitiesFilterId === "" ? colorsData.main_buttons : "transparent",
                transition: "all 0.3s ease-in-out"
              }}
              onClick = {() => {
                handleamenitiesFilter("", 0);
                handleamenitiesAttributesFilter([], 0)
                setSelectedamenityIndex(0);
                setSelectedamenityAttributeIndex(0);
                setSpinOpened(false);
              }}
              >
              <div 
                className='options-amenity-individual-name'
                style={{
                  color: selectedamenityAttributeIndex === 0 && amenitiesFilterId === "" ? colorsData.secondary_text:colorsData.main_text
                }}
              >
                Ver todas
            </div>
            </div>
            {
              (amenitiesData?.menu?.sort((a: any, b: any) => (a.attribute > b.attribute) ? 1 : -1)).map((group: any, ind: number) => 
                <div className='options-amenity-individual-btn'
                style = {{
                  backgroundColor: selectedamenityAttributeIndex === ind + 1 || amenitiesFilterId === group.attribute_id ? colorsData.main_buttons : 'transparent'
                }}
                onClick = {() => {
                  handleamenitiesFilter("", 0);
                  setSelectedamenityAttributeIndex(ind + 1);
                  setSelectedamenityIndex(-1)
                  handleamenitiesAttributesFilter(group.amenities, 40)
                }}
                >
                   <img src={selectedamenityAttributeIndex === ind + 1 ? all_white
                            : all} alt=''></img>
                  <div 
                    className='options-amenity-individual-name'
                    style = {{
                      color: selectedamenityAttributeIndex === ind + 1 ? colorsData.secondary_text: colorsData.main_text 
                    }}
                    >{group.attribute}</div>
                </div>
                
              )
            }
          </div>
        </div>:null
      }
      {
        !isamenitiesHidden && amenitiesFilterAttributeId?.length > 0 ?
        <div className='options-amenities-container-mobile' style={{marginTop: "1rem"}}>
          {/* <div className='options-amenities-name'>
            <img src={amenitiesData.icon} alt=""/>
            <div>Amenidades</div>
          </div> */}
          <div className='options-amenities-btns-container'>
            {/* <div 
              className='options-amenity-individual-btn'
              style={{
                backgroundColor: selectedamenityIndex === 0 && amenitiesFilterId === "" ? colorsData.main_buttons : amenityIndex === 0 ? colorsData.secondary_buttons: "transparent",
                transition: "all 0.3s ease-in-out"
              }}
              onClick = {() => {
                  handleamenitiesFilter("", 0)
                  setSelectedamenityIndex(0) 
              }}
              >
              <div 
                className='options-amenity-individual-name'
                style={{
                  color: selectedamenityIndex === 0 && amenitiesFilterId === "" ? colorsData.secondary_text:colorsData.main_text
                }}
              >
                Ver todas
            </div>
            </div> */}
            {
              amenitiesFilterAttributeId?.map((amenity: any, index: number) => 
                <div className='options-amenity-individual-btn'
                style = {{
                  backgroundColor: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? colorsData.main_buttons : amenityIndex === index + 1 ? colorsData.secondary_buttons: 'transparent'
                }}
                onClick = {() => {
                    handleamenitiesFilter(amenity.id, amenity.mainFrame)
                    setSelectedamenityIndex(index + 1)
                    setSpinOpened(false)
                    selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? setSelectedamenityIndex(index + 1) : setamenityOptionSelectedIndex(-1)
                    //handleamenitiesMenySelection(amenityMenu)
                    setTimeout(() => {
                      handleamenitiesMenySelection(
                        amenity?.menu?.length > 0 ? amenity?.menu?.find((e: any) => e.name === "Renders 2D") : ""
                      );
                    }, 700); 
                }}
                >
                   <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+amenity.icon.replace(' ', '+')} alt='' style={{filter: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? 'invert(1) brightness(100%)':'none'}}></img>
                  <div
                    className='options-amenity-individual-name'
                    style = {{
                      color: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? colorsData.secondary_text: colorsData.main_text 
                    }}
                    >{amenity.name}</div>
                </div>
              )
            }
          </div>
        </div>:null
      }
      {
            ((selectedamenityIndex > 0) && !isamenitiesHidden && amenitiesFilterAttributeId[selectedamenityIndex - 1] && 
            (amenitiesFilterAttributeId[selectedamenityIndex - 1]?.menu?.length > 0 || amenitiesFilterAttributeId[selectedamenityIndex - 1]?.spinPortrait !== null) ) ?
            <div className='amenities-options-selection-menu-mobile'>
              {
                amenitiesFilterAttributeId[selectedamenityIndex - 1].menu.map((amenityMenu: any, index: number) => 
                  <div className='options-selection-menu-mobile-individual'
                  key={amenityMenu.name + index}
                  style={{
                      backgroundColor: amenityOptionIndex === index || amenityOptionSelectedIndex === index ? "#E0E0E0":'transparent'
                  }}
                  onClick = {() => {
                    //setamenityOptionSelectedIndex(indexamenity)
                    handleamenitiesMenySelection(amenityMenu)
                  }}
                  >
                    <img src={amenityMenu.icon} alt={""}/>
                    <div 
                      className='amenity-individual-name'
                      style = {{
                          color: colorsData.main_text
                      }}
                    >
                        {amenityMenu.name}
                    </div>
                  </div>
                )
              }
              {
                                                    amenitiesFilterAttributeId[selectedamenityIndex - 1].spinPortrait !== null ?
                                                    <div 
                                                            className='options-selection-menu-mobile-individual'
                                                            style={{
                                                                backgroundColor: spinOpened ? colorsData.main_buttons:'transparent',
                                                            }}
                                                            onClick = {() => {
                                                                setSpinOpened(!spinOpened)
                                                                setSpinData(amenitiesFilterAttributeId[selectedamenityIndex - 1].spinPortrait)
                                                            }}
                                                        >
                                                            <object type="image/svg+xml;utf8" data={'./UI/amenities/recorrido.svg'} className="svg-img" id = {spinOpened ? 'selected-btn-amenities-spin':'unselected-btn-amenities'}>.</object>
                                                            <div 
                                                                className='amenity-individual-name'
                                                                style = {{
                                                                    color: spinOpened ? colorsData.secondary_text:colorsData.main_text
                                                                }}
                                                            >
                                                                Spin {amenitiesFilterAttributeId[selectedamenityIndex - 1].spinPortrait.count_files === 25 ? '180º':'360º'}
                                                            </div>
                                                        </div>:null
                                                }
            </div>:null
      }
    </div>
  )
}

export default SidebarAmenitiesV2Mobile